import React, {Component} from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card'
import { Typography } from 'rmwc/Typography';
import { TextField } from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'
import { ListDivider } from 'rmwc/List'
import { Link } from 'react-router-dom'
import { Radio } from 'rmwc/Radio'


class AdminDiscountAddUpdate extends Component {

	constructor(props){
		super(props)
		this.state = {
			data: {
				certificationTypeId: 4,
				certificationTypes: [],
				discountId: 0,
				code: '',
				percentage: '',
				active: 1,
			},
			formErrors: {
				codeError: '',
				certificationTypeIdError: '',
				activeInactiveError: '',
				percentageError: '',
			},
			disableState: {
				addUpdateDisable: false,
				disableCode: false,
				disableCertificationTypeId: false,
			},
			errorMsg: '',
			initalLoadingComplete: false,
		}
	}

	componentDidMount(){
		let data = Object.assign({}, this.state.data)
		let disableState = Object.assign({}, this.state.disableState)
		let discountId = parseInt(this.props.match.params.discountId)
		let certificationTypeUrl = 'admin/certification/types'
		return api.getResponse(this.props.user.accessToken, certificationTypeUrl)
		.then((result) => {
			if(result.status === 'success'){
				data.certificationTypes = result.data
			}
			if(discountId === 0){
				this.setState({data: data, initalLoadingComplete: true})
			}
			else{
				let url = `/admin/discount/show/${discountId}`
				return api.getResponse(this.props.user.accessToken, url)
				.then((result) => {
					if(result.status === 'success'){
						data.discountId = result.data.id
						data.code = result.data.code
						data.percentage = result.data.percentage
						data.active = result.data.active
						data.certificationTypeId = result.data.certification_type_id
						disableState.disableCode = true
						disableState.disableCertificationTypeId = true
						this.setState({data: data, initalLoadingComplete: true, disableState: disableState})
					}
					else if(result.status === 'error'){
						this.setState({errorMsg: 'Error in fetching Details.'})
					}
				}).catch((err) => {
					this.setState({errorMsg: 'Exception.Error fetching details of discount.'})
				})
			}
		}).catch((err) => {
			this.setState({errorMsg: 'Exception.Error in fetching details.'})
		})
	}

	onInputChange = (e) => {
		let data = Object.assign({}, this.state.data)
		data[e.target.name] = e.target.value
		this.setState({data: data})
	}

	handleCertificationTypeChange = (e) => {
		let data = Object.assign({}, this.state.data)
		data.certificationTypeId = e.target.value
		this.setState({data: data})
	}

	validateForm = () => {
		let data = Object.assign({}, this.state.data)
		let errorObj = Object.assign({}, this.state.formErrors)
		let error = false

		errorObj.codeError = ''
		errorObj.certificationTypeIdError = ''
		errorObj.activeInactiveError = ''
		errorObj.percentageError = ''

		if(!data.code){
			errorObj.codeError = "Code is mandatory"
			error = true
		}

		if(!data.certificationTypeId){
			errorObj.certificationTypeIdError = "Please choose the certification type."
			error = true
		}

		if(!data.percentage){
			errorObj.percentageError = "Percentage value is mandatory"
			error = true
		}
		else if(parseFloat(data.percentage) > 99.99){
			errorObj.percentageError = "Percentage cannot be greater than 99.99"
			error = true
		}

		if(!data.active){
			errorObj.activeInactiveError = "Please choose the status"
			error = true
		}

		this.setState({formErrors: errorObj})
		return error
	}

	handleAddUpdate = (e) => {
		let data = Object.assign({}, this.state.data)
		let disableState = Object.assign({}, this.state
			.disableState)
		let apiInput
		if(!this.validateForm()){
			if(data.discountId === 0){
				let url = `admin/discount/create`
				apiInput = {
					'code': this.state.data.code,
					'percentage': this.state.data.percentage,
					'certification_type_id': this.state.data.certificationTypeId,
					'active': this.state.data.active
				}
				return api.postValuesApi(this.props.user.accessToken, url, apiInput)
				.then((result) =>{
					if(result.status === 'success'){
						disableState.addUpdateDisable = true
						this.setState({errorMsg: result.message, disableState: disableState})
					}
					else {
						this.setState({errorMsg: result.message})
					}
				}).catch((err) =>{
					this.setState({errorMsg: 'Exception while creating'})
				})
			}
			else if(data.discountId > 0){
				let url = `/admin/discount/update/${data.discountId}`
				apiInput = {
					'percentage': this.state.data.percentage,
					'active': this.state.data.active
				}
				return api.putValuesApi(this.props.user.accessToken, url, apiInput)
				.then((result) =>{
					if(result.status === 'success'){
						disableState.addUpdateDisable = true
						this.setState({errorMsg: result.message,  disableState: disableState})
					}
					else {
						this.setState({errorMsg: result.message})
					}
				}).catch((err) =>{
					this.setState({errorMsg: 'Exception while updating'})
				})
			}
		}
	}

	handleBack = (e) => {
		e.preventDefault()
		this.props.history.push('/portal/app/admin/discounts')
	}

	render(){
		let formComponent, buttonComponent
		if(this.state.initalLoadingComplete){
			formComponent = (<Grid>

				<GridCell span="5">
					<Select
						onChange={this.handleCertificationTypeChange}
						value = {this.state.data.certificationTypeId}
						className="select-component"
						disabled={this.state.disableState.disableCertificationTypeId}
					>
					{this.state.data.certificationTypes.map(certification => (
						<option key={certification.id} value={certification.id}>{certification.name}</option>
					))}

					</Select>
				</GridCell>

				<GridCell span="12">
          <TextField className='text-input' label="Code" autoComplete="off" name="code" onChange={this.onInputChange} value={this.state.data.code} disabled={this.state.disableState.disableCode}/>
        </GridCell>
        
        <GridCell span="12">
          <TextField type="number" className="text-input" label="Percentage" autoComplete="off" name="percentage" onChange={this.onInputChange} value={this.state.data.percentage}/>  
        </GridCell>
      
        <GridCell span="12">
          Status:
          <Radio name="active" value={1} checked={this.state.data.active == '1'} onChange={this.onInputChange}> Active </Radio>
          <Radio name="active" value={0} checked={this.state.data.active == '0'} onChange={this.onInputChange}> In Active </Radio>
        </GridCell>
        <GridCell span="6"></GridCell>

				</Grid>
			)

			if(this.state.data.discountId === 0){
				buttonComponent = (
					<GridCell span="12">
						<Button raised disabled={this.state.disableState.addUpdateDisable} onClick={this.handleAddUpdate}>Add</Button>
					</GridCell>
				)
			}
			else if(this.state.data.discountId > 0) {
				buttonComponent = (
					<GridCell span="12">
						<Button raised disabled={this.state.disableState.addUpdateDisable} onClick={this.handleAddUpdate}>Update</Button>
					</GridCell>
				)
			}
		}
		return(
			<div>
				<Card style={{padding: '10px'}}>
					<Grid>
						<GridCell span="11">
							<Typography use="headline6">Add/Update Discount</Typography>
						</GridCell>
						<GridCell span="1">
							<Button raised onClick={this.handleBack}>Back</Button>
						</GridCell>
					</Grid>
				</Card>
				{formComponent}
				<Grid>
					{buttonComponent}
					<GridCell span="12">
						<StatusMessage error_msg = {this.state.errorMsg} />
						<StatusMessage error_msg = {this.state.formErrors.codeError} />
						<StatusMessage error_msg = {this.state.formErrors.percentageError} />
						<StatusMessage error_msg = {this.state.formErrors.activeInactiveError} />
						<StatusMessage error_msg = {this.state.formErrors.certificationTypeIdError} />
					</GridCell>
				</Grid>
			</div>
		)	
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDiscountAddUpdate);



// WEBPACK FOOTER //
// ./src/views/admin/AdminDiscountAddUpdate.jsx